export default __webpack_public_path__ + "static/media/logo.4d6c9b85.svg";